@import "../../../theme/global";

lar-list-item {
  margin: 0.4rem 0;
}
